import { useCallback, useMemo } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const CONTENT_TYPE_KEYS = [{
  key: 'academyCommon.contentTypes.TRACK',
  value: 'TRACK'
}, {
  key: 'academyCommon.contentTypes.LESSON',
  value: 'LESSON'
}, {
  key: 'academyCommon.contentTypes.SHORT_FORM_CONTENT',
  value: 'SHORT_FORM_CONTENT'
}, {
  key: 'academyCommon.contentTypes.PLAYLIST',
  value: 'PLAYLIST'
}, {
  key: 'academyCommon.contentTypes.HUBSPOT_PLAYLIST',
  value: 'LEARNING_PATH'
}];
const ButtonContent = ({
  count
}) => {
  if (count === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.filters.contentType.noneSelectedLabel"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.filters.contentType.someSelectedLabel",
    options: {
      count
    }
  });
};
const ContentTypeFilter = ({
  onChange,
  selectedTypes
}) => {
  const handleChange = useCallback(event => {
    onChange(event.target.value);
  }, [onChange]);
  const options = useMemo(() => CONTENT_TYPE_KEYS.map(({
    key,
    value
  }) => ({
    text: I18n.text(key),
    value
  })), []);
  return /*#__PURE__*/_jsx(Select, {
    ButtonContent: ButtonContent,
    anchorType: "button",
    buttonContentProps: {
      count: selectedTypes.length
    },
    buttonUse: "transparent",
    menuWidth: 250,
    multi: true,
    onChange: handleChange,
    options: options,
    value: selectedTypes
  });
};
export default ContentTypeFilter;